import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import {
  BRIEF_FACETS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_QUERY_KEY,
} from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBreifInfIdFacetsResult } from "@shared/lib/types/briefInfluencerV2";

export function useGetBriefInfluencerIdFacets(
  influencerId: string,
  socialMediaId?: string
) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<IBreifInfIdFacetsResult>
  >({
    queryKey: [...BRIEF_INFLUENCER_V2_QUERY_KEY, influencerId, "facets"],
    queryFn: () =>
      BriefService.getBriefInfluencerV2Facets(influencerId, socialMediaId),
    enabled: !!influencerId || !!socialMediaId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data,
    isFetching: isLoading,
  };
}
